import { MutationTree } from 'vuex';
import { RouteConfig } from 'vue-router';
import { USER } from '../mutation_types';
import { IUSERSTATE, IAUTH } from '../state.d';
import actions from '../actions/user';

const state: IUSERSTATE = {
  auth: JSON.parse(window.sessionStorage.getItem('auth') as string) || {},
  menuRoutes: JSON.parse(window.sessionStorage.getItem('menuRoutes') as string) || [],
  menus: [],
  stairMenus: [],
  btns: JSON.parse(window.sessionStorage.getItem('btns') as string) || [],
};

/* eslint-disable no-param-reassign */
const mutations: MutationTree<IUSERSTATE> = {
  [USER.SET_USER_MENU_ROUTES]: (s, routes: Array<{ id: number, path: string }>) => {
    s.menuRoutes = routes;
    window.sessionStorage.setItem('menuRoutes', JSON.stringify(routes));
  },
  [USER.SET_USER_AUTH]: (s, auth: IAUTH) => {
    s.auth = auth;
    window.sessionStorage.setItem('auth', JSON.stringify(auth));
  },
  [USER.SET_USER_MENUS]: (s, menus: Array<RouteConfig>) => {
    s.menus = menus;
  },
  [USER.SET_USER_STAIR_MENUS]: (s, menus: Array<RouteConfig>) => {
    s.stairMenus = menus;
  },
  [USER.SET_USER_BTNS]: (s, btns: Array<string>) => {
    s.btns = btns;
    window.sessionStorage.setItem('btns', JSON.stringify(btns));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
